<template>
    <div class="distributor-account-safe">
      <div class="common-header-wrap">
        <mt-header :title="$t('distributor.account.account_safe')" class="common-header">
          <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        </mt-header>
      </div>
      <div class="menu-list main-content">
		<div @click='editPasswordVisible=true'>
		    <flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">{{ $t('distributor.account.modify_login_password') }}</span></flex-line>
		</div>
		<div @click='editMobileVisible=true'>
		    <flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">{{ $t('distributor.account.modify_tel_number', [user.phone]) }}</span></flex-line>
		</div>
		<div @click='editEmailVisible=true'>
		    <flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">{{ $t('distributor.account.modify_email', [user.email]) }}</span></flex-line>
		</div>
      </div>

			<!--修改手机-->
			<mt-popup v-model="editMobileVisible" position="right" class="common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header :title="$t('distributor.account.modify_tel_number', [''])" class="common-header">
          <mt-button slot="left" icon="back" @click="editMobileVisible=false"></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content">
			<div class='main-content'>
				<flex-line class="field-line menu-item" :show-border="true" style="padding-top: 2rem;">
          <span class="field-name">{{ $t('distributor.account.login_password') }}</span>
          <div class="field-line-right" slot="right">
            <input class="field-input" type="password" v-model="$v.rebind_mobile.password.$model" :placeholder="$t('distributor.account.login_password')" />
          </div>
        </flex-line>
				<flex-line class="field-line menu-item" :show-border="true"><span class="field-name">{{ $t('distributor.account.new_tel_number') }}</span><div class="field-line-right" slot="right"><input class="field-input" type="text" v-model="$v.rebind_mobile.mobile.$model" :placeholder="$t('distributor.account.new_tel_number')"/></div></flex-line>
        <flex-line v-if="user.sms_rebind_mobile == '1'" class="field-line" :show-border="true">
          <span class="field-name">{{ $t('distributor.account.sms_captcha') }}</span>
          <div class="field-line-right" slot="right">
            <input class="field-input" v-model="$v.rebind_mobile.captcha.$model" />
            <mt-button class="common-btn send-btn" size='small' type='primary' :disabled="!canSend || $v.rebind_mobile.mobile.$invalid" @click='sendSmsCaptcha(get_sms_captcha_types.rebind_mobile, $v.rebind_mobile.mobile.$model)'>{{sendStateText}}</mt-button>
            <!-- <div @click="sendSmsCaptcha(get_sms_captcha_types.rebind_mobile, $v.rebind_mobile.mobile.$model)" class="common-btn send-btn">{{sendStateText}}</div> -->
          </div>
        </flex-line>
        <mt-button size="large" type='primary' class='common-btn mt-10 ds-button-large' @click="updateMobile" :disabled="$v.rebind_mobile.$invalid">{{ $t('general.confirm') }}</mt-button>
			</div>
		</div>
    </mt-popup>

		<!--修改邮箱-->
			<mt-popup v-model="editEmailVisible" position="right" class="common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header :title="$t('distributor.account.modify_email', [''])" class="common-header">
          <mt-button slot="left" icon="back" @click="editEmailVisible=false"></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content" style="padding-top: 2rem;">
		  <div class='main-content'>
		  	<flex-line class="field-line menu-item" :show-border="true"><span class="field-name">{{ $t('distributor.account.login_password') }}</span><div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="password" /></div></flex-line>
		  	<flex-line class="field-line menu-item" :show-border="true"><span class="field-name">{{ $t('distributor.account.new_email') }}</span><div class="field-line-right" slot="right"><input class="field-input" type="text" v-model="email" /></div></flex-line>
		  	<div class="common-btn ds-button-large mt-10" @click="updateEmail">{{ $t('general.confirm') }}</div>
		  </div>
		</div>
    </mt-popup>

		<!--修改密码-->
			<mt-popup v-model="editPasswordVisible" position="right" class="common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header :title="$t('distributor.account.modify_login_password')" class="common-header">
          <mt-button slot="left" icon="back" @click="editPasswordVisible=false"></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content" style="padding-top: 2rem;">
		<div class='main-content'>
			<flex-line class="field-line menu-item" :show-border="true"><span class="field-name">{{ $t('distributor.account.new_password') }}</span><div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="password1" /></div></flex-line>
			<flex-line class="field-line menu-item" :show-border="true"><span class="field-name">{{ $t('distributor.account.confirm_password') }}</span><div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="password2" /></div></flex-line>
			<flex-line :show-border="true">
				<span>{{ $t('distributor.account.captcha_type') }}</span>
				<div slot="right">
					<mt-radio
							v-model="verifyType"
							:options="verifyTypeOptions">
					</mt-radio>
				</div>
			</flex-line>
			<flex-line class="field-line" :show-border="true"><span class="field-name">{{ $t('distributor.account.captcha') }}</span><div class="field-line-right" slot="right"><input class="field-input" v-model="verifyCode" /><div @click="sendVerifyCode" class="common-btn send-btn">{{sendStateText}}</div></div></flex-line>
			<div class="common-btn ds-button-large mt-10" @click="updatePassword">{{ $t('general.confirm') }}</div>
		</div>
	</div>
    </mt-popup>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { Toast } from 'mint-ui'
import { sendVerifyCode } from '../../../api/common'
import { updateUserMobile, updateUserEmail, updateUserPassword } from '../../../api/distributorUser'
import { getSmsCaptcha, checkVerifyCode, checkSmsCaptcha } from '@src/api/common'
import { maxLength, minLength, required, requiredIf } from 'vuelidate/lib/validators'
import validator from '@src/util/validator'
import flexLine from '../../flexLine'
export default {
	components: {
	  flexLine
	},
  name: 'DistributorAccountSafe',
  validations: {
    rebind_mobile: {
      password: {
        required,
        maxLength: maxLength(20),
        minLength: minLength(6)
      },
      mobile: {
        required,
        mobile: validator.mobile
      },
      captcha: {
        required: requiredIf(function() { return this.user.sms_rebind_mobile === '1' }),
        maxLength: maxLength(6),
        minLength: minLength(6)
      }
    }
  },
  data () {
    return {
      rebind_mobile: {
        password: '',
        mobile: '',
        captcha: '',
      },
      editMobileVisible: false,
      password: '',
      mobile: '',
      editEmailVisible: false,
      email: '',
      editPasswordVisible: false,
      password1: '',
      password2: '',
      verifyType: 'email',
      verifyCode: '',
      canSend: true,
      time_interval: false,
      sendStateText: this.$t('distributor.action.send'),
      get_sms_captcha_types: {
        register: 1,
        login: 2,
        forgot_password: 3,
        rebind_mobile: 4
      },
      verifyTypeOptions: [
        {
          label: this.$t('distributor.account.email'),
          value: 'email'
        },
        {
          label: this.$t('distributor.account.mobile'),
          value: 'mobile'
        }
      ]
    }
  },
  beforeDestroy: function () {
    clearInterval(this.time_interval)
  },
  computed: {
    ...mapState({
      user: state => state.distributor.info
    })
  },
  methods: {
    ...mapMutations({
      distributorEdit: 'distributorEdit'

    }),
    updateMobile () {
      checkSmsCaptcha(this.get_sms_captcha_types.rebind_mobile, this.$v.rebind_mobile.mobile.$model, this.$v.rebind_mobile.captcha.$model)
        .then(res => {
          updateUserMobile(this.$v.rebind_mobile.password.$model, this.$v.rebind_mobile.mobile.$model).then(res => {
            this.distributorEdit({ phone: this.$v.rebind_mobile.mobile.$model })
            Toast(res.message)
            this.$router.go(0)
          }).catch(function (error) {
            Toast(error.message)
          })
        })
        .catch(function (error) {
          Toast(error.message)
        })
    },
    updateEmail () {
      updateUserEmail(this.password, this.email).then(res => {
        this.distributorEdit({ email: this.email })
        Toast(res.message)
        this.$router.go(0)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    updatePassword () {
      updateUserPassword(this.password1, this.password2, this.verifyCode).then(res => {
        Toast(res.message)
        this.$router.go(0)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    createReciprocalTimer(msg) {
      this.canSend = false
      let _this = this
      let second = 60
      Toast(msg)
      this.time_interval = setInterval(function () {
        if (second <= 0) {
          _this.canSend = true
          _this.sendStateText = _this.$t('distributor.action.send')
          clearInterval(_this.time_interval)
        } else {
          _this.sendStateText = second + 's'
        }
        second--
      }, 1000)
    },
    sendSmsCaptcha (type, mobile) {
      getSmsCaptcha(type, mobile).then((res) => {
        this.createReciprocalTimer(res.message)
      })
      .catch((error) => {
        Toast(error.message)
      })
    },
    sendVerifyCode () {
      if (!this.canSend) {
        return
      }
      sendVerifyCode(this.verifyType, 3, 3,this.user.user_name).then(res => {
        _this.createReciprocalTimer(res.message)
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>

<style  lang="scss" scoped>
	.main-content{background: #fff;padding:0 $pageSpace}
  .distributor-account-safe {position:relative;z-index:100;
	.btn{width:4rem}
	.common-popup-content{
	      .mint-radiolist {
        display: flex;
        .mint-cell {
          flex: 1;
          .mint-radio-input:checked + .mint-radio-core {
            background-color: #ff9900 !important;
            border-color: #ff9900 !important;
          }
        }
      }
	}
  .menu-list{
  .menu-item {
		.right-arrow{transform: rotate(-90deg);color:#ddd;font-size: .6rem;}
  }
  }
  }
</style>
